import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import CompanyRegistrationHeader1 from '../components/Service/Consultation/CompanyRegistrationHeader1';
import CompanyRegistrationInfo from '../components/Service/HrRecruitment/CompanyRegistrationInfo';
import ConditionsForRegister from '../components/Service/HrRecruitment/ConditionsForRegister';
import RegistrationProcess from '../components/Service/HrRecruitment/RegistrationProcess';
import Share from '../components/Share';
import SideOverlap from './sideOverlap';
import ConsultationMain from '../components/Service/Consultation/ConsultationMain';

export default function Consultation() {
    return (
        <>
            <Header />
            <CompanyRegistrationHeader1 />
            <ConsultationMain />
            {/* <CompanyRegistrationInfo />
            <ConditionsForRegister />
            <RegistrationProcess /> */}
            
            <Share />
            <Footer />
            <SideOverlap/>
        </>
    )
}
